"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const GraphTree = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M8 0h.405c.655 0 1.519.623 1.835.909.589.576.96 1.382.96 2.291s-.371 1.715-.96 2.291l2.06 4.16c.167-.05.334-.05.5-.05a3.201 3.201 0 010 6.399 3.201 3.201 0 01-3.2-3.2c0-.896.384-1.715.986-2.291l-2.087-4.16C8.32 6.4 8.166 6.4 8 6.4c-.166 0-.32 0-.5-.051l-2.073 4.16c.602.576.973 1.395.973 2.291a3.201 3.201 0 01-6.4 0c0-1.766 1.434-3.2 3.2-3.2.166 0 .333 0 .5.051l2.06-4.16a3.24 3.24 0 01-.96-2.29C4.8 1.433 6.234 0 8 0z",
  fill: "#000",
  className: "fill"
}));
var _default = exports.default = GraphTree;